/** Placas / radiografías dentales almacenadas en el expediente clínico (demo + persistencia local). */

export type TipoPlacaDental = 'PERIAPICAL' | 'BITEWING' | 'PANORAMICA' | 'CBCT' | 'OTRO';

export type PlacaDental = {
  id: string;
  pacienteId: string;
  cui?: string | null;
  fecha: string;
  tipo: TipoPlacaDental;
  dientes: string;
  nota: string;
  medico: string;
  archivoNombre?: string;
  imagenUrl?: string;
  registradaEn?: string;
};

const STORAGE_KEY = 'toscana.expediente.placas';

function readAll(): PlacaDental[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PlacaDental[]) : [];
  } catch {
    return [];
  }
}

function writeAll(items: PlacaDental[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function listPlacas(pacienteId: string): PlacaDental[] {
  return readAll()
    .filter(p => p.pacienteId === pacienteId)
    .sort((a, b) => (b.fecha + b.registradaEn).localeCompare(a.fecha + a.registradaEn));
}

export function addPlaca(input: Omit<PlacaDental, 'id' | 'registradaEn'>): PlacaDental {
  const placa: PlacaDental = {
    ...input,
    id: crypto.randomUUID(),
    registradaEn: new Date().toISOString(),
  };
  const all = readAll();
  all.push(placa);
  writeAll(all);
  return placa;
}

export function removePlaca(id: string): void {
  writeAll(readAll().filter(p => p.id !== id));
}

export function seedPlacasDemo(items: PlacaDental[]): void {
  const byId = new Map(readAll().map(p => [p.id, p]));
  for (const item of items) {
    byId.set(item.id, item);
  }
  writeAll([...byId.values()]);
}
